module.exports = __webpack_public_path__ + "img/qr_code_more.ce977870.png";